import { useAppStore } from '@/store/useAppStore.ts'
import { BatteryChemistry, type BatteryChemistry as ChemistryType } from '@brt/shared-types'
import { Badge } from '@/components/shared/Badge.tsx'
import { Select } from 'calc-controls'

const CHEMISTRIES = [
  { value: BatteryChemistry.LI_FEPO4, label: 'LiFePO₄', color: 'chem-lifepo4' },
  { value: BatteryChemistry.LI_ION, label: 'Li-ion', color: 'chem-liion' },
  { value: BatteryChemistry.LEAD_ACID_FLOODED, label: 'Lead-Acid', color: 'chem-leadacid' },
  { value: BatteryChemistry.AGM, label: 'AGM', color: 'chem-leadacid' },
  { value: BatteryChemistry.GEL, label: 'GEL', color: 'chem-leadacid' },
  { value: BatteryChemistry.NI_MH, label: 'NiMH', color: 'chem-nimh' },
  { value: BatteryChemistry.NI_CD, label: 'NiCd', color: 'chem-nimh' },
  { value: BatteryChemistry.ALKALINE, label: 'Alkaline', color: 'chem-alkaline' },
  { value: BatteryChemistry.CUSTOM, label: 'Custom', color: 'default' },
] as const

const CHEMISTRY_OPTIONS = CHEMISTRIES.map((c) => ({ value: c.value, label: c.label }))

export function ChemistrySelector() {
  const chemistry = useAppStore((s) => s.battery.chemistry)
  const setChemistry = useAppStore((s) => s.setChemistry)
  const active = CHEMISTRIES.find((c) => c.value === chemistry)

  return (
    <div className="chemistry-selector">
      <div className="chemistry-selector__row">
        {active && (
          <span className={`chemistry-selector__dot chemistry-selector__dot--${active.color}`} aria-hidden="true" />
        )}
        <Select
          label="Chemistry"
          options={CHEMISTRY_OPTIONS}
          value={chemistry}
          onChange={(v) => setChemistry(v as ChemistryType)}
        />
      </div>
      {active && active.value !== BatteryChemistry.CUSTOM && (
        <Badge variant="info">{active.label}</Badge>
      )}
    </div>
  )
}
